export default {
  auditSourceIdentificationCode: {
    "1": {
      code: "1",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "User Device",
    },
    "2": {
      code: "2",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Data Interface",
    },
    "3": {
      code: "3",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Web Server",
    },
    "4": {
      code: "4",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Application Server",
    },
    "5": {
      code: "5",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Database Server",
    },
    "6": {
      code: "6",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Security Server",
    },
    "7": {
      code: "7",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Network Device",
    },
    "8": {
      code: "8",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Network Router",
    },
    "9": {
      code: "9",
      system: "2.16.840.1.113883.4.642.1.460",
      display: "Other",
    },
  },
  eprAuditTrailConsumptionEventType: {
    ATC_DOC_CREATE: {
      code: "ATC_DOC_CREATE",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Document upload",
    },
    ATC_DOC_READ: {
      code: "ATC_DOC_READ",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Document retrieval",
    },
    ATC_DOC_UPDATE: {
      code: "ATC_DOC_UPDATE",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Document or Document Metadata update",
    },
    ATC_DOC_DELETE: {
      code: "ATC_DOC_DELETE",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Document removal",
    },
    ATC_DOC_SEARCH: {
      code: "ATC_DOC_SEARCH",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Document search",
    },
    ATC_POL_CREATE_AUT_PART_AL: {
      code: "ATC_POL_CREATE_AUT_PART_AL",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Authorize participants to access level/date",
    },
    ATC_POL_UPDATE_AUT_PART_AL: {
      code: "ATC_POL_UPDATE_AUT_PART_AL",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Update access level/date of authorized participants",
    },
    ATC_POL_REMOVE_AUT_PART_AL: {
      code: "ATC_POL_REMOVE_AUT_PART_AL",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Remove authorization for participants to access level/date",
    },
    ATC_POL_DEF_CONFLEVEL: {
      code: "ATC_POL_DEF_CONFLEVEL",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Set or update the default Confidentiality Level for new documents",
    },
    ATC_POL_DIS_EMER_USE: {
      code: "ATC_POL_DIS_EMER_USE",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Disabling Emergency Access",
    },
    ATC_POL_ENA_EMER_USE: {
      code: "ATC_POL_ENA_EMER_USE",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Enabling Emergency Access",
    },
    ATC_POL_INCL_BLACKLIST: {
      code: "ATC_POL_INCL_BLACKLIST",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Assign a Healthcare Professional to Blacklist",
    },
    ATC_POL_EXL_BLACKLIST: {
      code: "ATC_POL_EXL_BLACKLIST",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Exclude a Healthcare Professional from Blacklist",
    },
    ATC_LOG_READ: {
      code: "ATC_LOG_READ",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Accessing the Patient Audit Record Repository",
    },
    ATC_HPD_GROUP_ENTRY_NOTIFY: {
      code: "ATC_HPD_GROUP_ENTRY_NOTIFY",
      system: "2.16.756.5.30.1.127.3.10.7",
      display: "Entry of healthcare professionals into a group",
    },
  },
  eventActionCode: {
    C: {
      code: "C",
      system: "2.16.840.1.113883.4.642.1.446",
      display: "Create",
    },
    R: {
      code: "R",
      system: "2.16.840.1.113883.4.642.1.446",
      display: "Read",
    },
    U: {
      code: "U",
      system: "2.16.840.1.113883.4.642.1.446",
      display: "Update",
    },
    D: {
      code: "D",
      system: "2.16.840.1.113883.4.642.1.446",
      display: "Delete",
    },
    E: {
      code: "E",
      system: "2.16.840.1.113883.4.642.1.446",
      display: "Execute",
    },
  },
  eventOutcomeIndicator: {
    "0": {
      code: "0",
      system: "2.16.840.1.113883.4.642.1.448",
      display: "Success",
    },
    "4": {
      code: "4",
      system: "2.16.840.1.113883.4.642.1.448",
      display: "Minor failure",
    },
    "8": {
      code: "8",
      system: "2.16.840.1.113883.4.642.1.448",
      display: "Serious failure",
    },
    "12": {
      code: "12",
      system: "2.16.840.1.113883.4.642.1.448",
      display: "Major failure",
    },
  },
  mediaTypeCode: {
    "110030": {
      code: "110030",
      system: "1.2.840.10008.2.16.4",
      display: "USB Disk Emulation",
    },
    "110031": {
      code: "110031",
      system: "1.2.840.10008.2.16.4",
      display: "Email",
    },
    "110032": {
      code: "110032",
      system: "1.2.840.10008.2.16.4",
      display: "CD",
    },
    "110033": {
      code: "110033",
      system: "1.2.840.10008.2.16.4",
      display: "DVD",
    },
    "110034": {
      code: "110034",
      system: "1.2.840.10008.2.16.4",
      display: "Compact Flash",
    },
    "110035": {
      code: "110035",
      system: "1.2.840.10008.2.16.4",
      display: "Multi-media Card",
    },
    "110036": {
      code: "110036",
      system: "1.2.840.10008.2.16.4",
      display: "Secure Digital Card",
    },
    "110037": {
      code: "110037",
      system: "1.2.840.10008.2.16.4",
      display: "URI",
    },
    "110038": {
      code: "110038",
      system: "1.2.840.10008.2.16.4",
      display: "Film",
    },
    "110039": {
      code: "110039",
      system: "1.2.840.10008.2.16.4",
      display: "Paper Document",
    },
  },
  networkAccessPointTypeCode: {
    "1": {
      code: "1",
      system: "2.16.840.1.113883.4.642.1.450",
      display: "Machine Name",
    },
    "2": {
      code: "2",
      system: "2.16.840.1.113883.4.642.1.450",
      display: "IP Address",
    },
    "3": {
      code: "3",
      system: "2.16.840.1.113883.4.642.1.450",
      display: "Telephone Number",
    },
    "4": {
      code: "4",
      system: "2.16.840.1.113883.4.642.1.450",
      display: "Email address",
    },
    "5": {
      code: "5",
      system: "2.16.840.1.113883.4.642.1.450",
      display: "URI",
    },
  },
  participantObjectDataLifeCycle: {
    "1": {
      code: "1",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Origination, Creation",
    },
    "2": {
      code: "2",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Import/Copy",
    },
    "3": {
      code: "3",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Amendment",
    },
    "4": {
      code: "4",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Verification",
    },
    "5": {
      code: "5",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Translation",
    },
    "6": {
      code: "6",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Access/Use",
    },
    "7": {
      code: "7",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "De-identification",
    },
    "8": {
      code: "8",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Aggregation, summarization, derivation",
    },
    "9": {
      code: "9",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Report",
    },
    "10": {
      code: "10",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Export",
    },
    "11": {
      code: "11",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Disclosure",
    },
    "12": {
      code: "12",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Receipt of Disclosure",
    },
    "13": {
      code: "13",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Archiving",
    },
    "14": {
      code: "14",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Logical deletion",
    },
    "15": {
      code: "15",
      system: "2.16.756.5.30.1.127.77.10.5.3",
      display: "Permanent erasure, physical destruction",
    },
  },
  participantObjectTypeCode: {
    "1": {
      code: "1",
      system: "2.16.840.1.113883.4.642.1.903",
      display: "Person",
    },
    "2": {
      code: "2",
      system: "2.16.840.1.113883.4.642.1.903",
      display: "System Object",
    },
    "3": {
      code: "3",
      system: "2.16.840.1.113883.4.642.1.903",
      display: "Organization",
    },
    "4": {
      code: "4",
      system: "2.16.840.1.113883.4.642.1.903",
      display: "Other",
    },
  },
  participantObjectTypeCodeRole: {
    "1": {
      code: "1",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Patient",
    },
    "2": {
      code: "2",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Location",
    },
    "3": {
      code: "3",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Report",
    },
    "4": {
      code: "4",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Domain Resource",
    },
    "5": {
      code: "5",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Master file",
    },
    "6": {
      code: "6",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "User",
    },
    "7": {
      code: "7",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "List",
    },
    "8": {
      code: "8",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Doctor",
    },
    "9": {
      code: "9",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Subscriber",
    },
    "10": {
      code: "10",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Guarantor",
    },
    "11": {
      code: "11",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Security User Entity",
    },
    "12": {
      code: "12",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Security User Group",
    },
    "13": {
      code: "13",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Security Resource",
    },
    "14": {
      code: "14",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Security Granularity Definition",
    },
    "15": {
      code: "15",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Provider",
    },
    "16": {
      code: "16",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Report Destination",
    },
    "17": {
      code: "17",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Report Library",
    },
    "18": {
      code: "18",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Schedule",
    },
    "19": {
      code: "19",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Customer",
    },
    "20": {
      code: "20",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Job",
    },
    "21": {
      code: "21",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Job Stream",
    },
    "22": {
      code: "22",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Table (Deprecated)",
    },
    "23": {
      code: "23",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Routing Criteria",
    },
    "24": {
      code: "24",
      system: "2.16.840.1.113883.4.642.1.454",
      display: "Query",
    },
  },
  authorRole: {
    "3842006": {
      code: "3842006",
      system: "2.16.840.1.113883.6.96",
      display: "Chiropractor (occupation)",
    },
    "36682004": {
      code: "36682004",
      system: "2.16.840.1.113883.6.96",
      display: "Physiotherapist (occupation)",
    },
    "46255001": {
      code: "46255001",
      system: "2.16.840.1.113883.6.96",
      display: "Pharmacist (occupation)",
    },
    "59944000": {
      code: "59944000",
      system: "2.16.840.1.113883.6.96",
      display: "Psychologist (occupation)",
    },
    "80546007": {
      code: "80546007",
      system: "2.16.840.1.113883.6.96",
      display: "Occupational therapist (occupation)",
    },
    "106289002": {
      code: "106289002",
      system: "2.16.840.1.113883.6.96",
      display: "Dentist (occupation)",
    },
    "106292003": {
      code: "106292003",
      system: "2.16.840.1.113883.6.96",
      display: "Professional nurse (occupation)",
    },
    "116154003": {
      code: "116154003",
      system: "2.16.840.1.113883.6.96",
      display: "Patient (person)",
    },
    "133932002": {
      code: "133932002",
      system: "2.16.840.1.113883.6.96",
      display: "Caregiver (person)",
    },
    "158933003": {
      code: "158933003",
      system: "2.16.840.1.113883.6.96",
      display: "Social caseworker (general) (occupation)",
    },
    "159026005": {
      code: "159026005",
      system: "2.16.840.1.113883.6.96",
      display: "Speech/language therapist (occupation)",
    },
    "159033005": {
      code: "159033005",
      system: "2.16.840.1.113883.6.96",
      display: "Dietitian (occupation)",
    },
    "224609002": {
      code: "224609002",
      system: "2.16.840.1.113883.6.96",
      display: "Complementary health worker (occupation)",
    },
    "225726006": {
      code: "225726006",
      system: "2.16.840.1.113883.6.96",
      display: "Lactation consultant (occupation)",
    },
    "309343006": {
      code: "309343006",
      system: "2.16.840.1.113883.6.96",
      display: "Physician (occupation)",
    },
    "309453006": {
      code: "309453006",
      system: "2.16.840.1.113883.6.96",
      display: "Registered midwife (occupation)",
    },
  },
  authorSpeciality: {
    "1002": {
      code: "1002",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Surgery",
    },
    "1003": {
      code: "1003",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Gynaecology and obstetrics",
    },
    "1004": {
      code: "1004",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Cardiac and thoracic vascular surgery",
    },
    "1006": {
      code: "1006",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Paediatrics",
    },
    "1007": {
      code: "1007",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Ophthalmology",
    },
    "1008": {
      code: "1008",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Otorhinolaryngology",
    },
    "1009": {
      code: "1009",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Pathology",
    },
    "1010": {
      code: "1010",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Orthodontics",
    },
    "1011": {
      code: "1011",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Chiropractic specialist",
    },
    "1012": {
      code: "1012",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Anaesthesiology",
    },
    "1013": {
      code: "1013",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Neurosurgery",
    },
    "1014": {
      code: "1014",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Neurology",
    },
    "1015": {
      code: "1015",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Orthopaedic surgery and traumatology of the locomotor apparatus",
    },
    "1016": {
      code: "1016",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Pneumology",
    },
    "1017": {
      code: "1017",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Psychiatry and psychotherapy",
    },
    "1018": {
      code: "1018",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Urology",
    },
    "1019": {
      code: "1019",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Allergology and clinical immunology",
    },
    "1020": {
      code: "1020",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Occupational medicine",
    },
    "1021": {
      code: "1021",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Dermatology and venereology",
    },
    "1022": {
      code: "1022",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Endocrinology – Diabetology",
    },
    "1023": {
      code: "1023",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Gastroenterology",
    },
    "1024": {
      code: "1024",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Haematology",
    },
    "1025": {
      code: "1025",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Cardiology",
    },
    "1026": {
      code: "1026",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Oral and maxillofacial surgery",
    },
    "1027": {
      code: "1027",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Child and adolescent psychiatry and psychotherapy",
    },
    "1028": {
      code: "1028",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Paediatric surgery",
    },
    "1029": {
      code: "1029",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Clinical pharmacology and toxicology",
    },
    "1030": {
      code: "1030",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Radiology",
    },
    "1031": {
      code: "1031",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Nuclear medicine",
    },
    "1032": {
      code: "1032",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Radio-oncology / radiotherapy",
    },
    "1033": {
      code: "1033",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Nephrology",
    },
    "1034": {
      code: "1034",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Physical medicine and rehabilitation",
    },
    "1035": {
      code: "1035",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Plastic, reconstructive and aesthetic surgery",
    },
    "1036": {
      code: "1036",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Prevention and public health",
    },
    "1037": {
      code: "1037",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Rheumatology",
    },
    "1038": {
      code: "1038",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Tropical and travel medicine",
    },
    "1039": {
      code: "1039",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Infectology",
    },
    "1040": {
      code: "1040",
      system: "2.16.756.5.30.1.127.3.5",
      display: "General medical practitioner",
    },
    "1041": {
      code: "1041",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Angiology",
    },
    "1042": {
      code: "1042",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Intensive care medicine",
    },
    "1043": {
      code: "1043",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Medical genetics",
    },
    "1044": {
      code: "1044",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Medical oncology",
    },
    "1045": {
      code: "1045",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Pharmaceutical medicine",
    },
    "1046": {
      code: "1046",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Forensic medicine",
    },
    "1047": {
      code: "1047",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Oral surgery",
    },
    "1048": {
      code: "1048",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Paradontology",
    },
    "1049": {
      code: "1049",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Reconstructive dentistry",
    },
    "1050": {
      code: "1050",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Other",
    },
    "1051": {
      code: "1051",
      system: "2.16.756.5.30.1.127.3.5",
      display: "General Internal Medicine",
    },
    "1052": {
      code: "1052",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Offizinpharmazie",
    },
    "1053": {
      code: "1053",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Spitalpharmazie",
    },
    "1054": {
      code: "1054",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Psychotherapy",
    },
    "1055": {
      code: "1055",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Child and Adolescent Psychology",
    },
    "1056": {
      code: "1056",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Clinical Psychology",
    },
    "1057": {
      code: "1057",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Neuropsychology",
    },
    "1058": {
      code: "1058",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Health Psychology",
    },
    "1059": {
      code: "1059",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Hand surgery",
    },
    "1060": {
      code: "1060",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Vascular surgery",
    },
    "1061": {
      code: "1061",
      system: "2.16.756.5.30.1.127.3.5",
      display: "Thoracic surgery",
    },
    "5001": {
      code: "5001",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Optics",
    },
    "5002": {
      code: "5002",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Activation",
    },
    "5003": {
      code: "5003",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Biomedical analysis",
    },
    "5004": {
      code: "5004",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Dental hygiene",
    },
    "5005": {
      code: "5005",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Pharmaceutical",
    },
    "5006": {
      code: "5006",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Occupational Therapy",
    },
    "5007": {
      code: "5007",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Nutrition and Dietetics",
    },
    "5008": {
      code: "5008",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Radiologic Technology",
    },
    "5009": {
      code: "5009",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Surgical Technology",
    },
    "5010": {
      code: "5010",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Midwifery",
    },
    "5011": {
      code: "5011",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Speech and Language Therapy",
    },
    "5012": {
      code: "5012",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Massage Therapy",
    },
    "5013": {
      code: "5013",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Orthoptics",
    },
    "5014": {
      code: "5014",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Osteopathy",
    },
    "5015": {
      code: "5015",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Nursing",
    },
    "5016": {
      code: "5016",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Physiotherapy",
    },
    "5017": {
      code: "5017",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Podiatry",
    },
    "5018": {
      code: "5018",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Paramedics",
    },
    "5019": {
      code: "5019",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Optometry",
    },
    "5021": {
      code: "5021",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Naturopathy Ayurveda Medicine",
    },
    "5022": {
      code: "5022",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Naturopathy Homeopathy",
    },
    "5023": {
      code: "5023",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Naturopathy Traditional Chinese Medicine",
    },
    "5024": {
      code: "5024",
      system: "2.16.756.5.30.1.127.3.6",
      display: "Naturopathy European Traditional Medicine",
    },
  },
  classCode: {
    "184216000": {
      code: "184216000",
      system: "2.16.840.1.113883.6.96",
      display: "Patient record type (record artifact)",
    },
    "371525003": {
      code: "371525003",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical procedure report (record artifact)",
    },
    "371531000": {
      code: "371531000",
      system: "2.16.840.1.113883.6.96",
      display: "Report of clinical encounter (record artifact)",
    },
    "371537001": {
      code: "371537001",
      system: "2.16.840.1.113883.6.96",
      display: "Consent report (record artifact)",
    },
    "371538006": {
      code: "371538006",
      system: "2.16.840.1.113883.6.96",
      display: "Advance directive report (record artifact)",
    },
    "405624007": {
      code: "405624007",
      system: "2.16.840.1.113883.6.96",
      display: "Administrative documentation (record artifact)",
    },
    "417319006": {
      code: "417319006",
      system: "2.16.840.1.113883.6.96",
      display: "Record of health event (record artifact)",
    },
    "419891008": {
      code: "419891008",
      system: "2.16.840.1.113883.6.96",
      display: "Record artifact (record artifact)",
    },
    "422735006": {
      code: "422735006",
      system: "2.16.840.1.113883.6.96",
      display: "Summary clinical document (record artifact)",
    },
    "440545006": {
      code: "440545006",
      system: "2.16.840.1.113883.6.96",
      display: "Prescription record (record artifact)",
    },
    "721927009": {
      code: "721927009",
      system: "2.16.840.1.113883.6.96",
      display: "Referral note (record artifact)",
    },
    "721963009": {
      code: "721963009",
      system: "2.16.840.1.113883.6.96",
      display: "Order (record artifact)",
    },
    "722160009": {
      code: "722160009",
      system: "2.16.840.1.113883.6.96",
      display: "Audit trail report (record artifact)",
    },
    "722216001": {
      code: "722216001",
      system: "2.16.840.1.113883.6.96",
      display: "Emergency medical identification record (record artifact)",
    },
    "734163000": {
      code: "734163000",
      system: "2.16.840.1.113883.6.96",
      display: "Care Plan (record artifact)",
    },
    "772790007": {
      code: "772790007",
      system: "2.16.840.1.113883.6.96",
      display: "Organ donor card (record artifact)",
    },
    "2171000195109": {
      code: "2171000195109",
      system: "2.16.756.5.30.1.127.3.4",
      display: "Obstetrical Record (record artifact)",
    },
  },
  confidentialityCode: {
    "17621005": {
      code: "17621005",
      system: "2.16.840.1.113883.6.96",
      display: "Normal (qualifier value)",
    },
    "263856008": {
      code: "263856008",
      system: "2.16.840.1.113883.6.96",
      display: "Restricted (qualifier value)",
    },
    "1141000195107": {
      code: "1141000195107",
      system: "2.16.756.5.30.1.127.3.4",
      display: "Secret (qualifier value)",
    },
  },
  eventCodeList: {
    OPTENF: {
      code: "OPTENF",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Tomography En Face",
    },
    OPTBSV: {
      code: "OPTBSV",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Tomography B-scan Volume Analysis",
    },
    OPV: {
      code: "OPV",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Visual Field",
    },
    DX: {
      code: "DX",
      system: "1.2.840.10008.2.16.4",
      display: "Digital Radiography",
    },
    OPT: {
      code: "OPT",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Tomography",
    },
    BMD: {
      code: "BMD",
      system: "1.2.840.10008.2.16.4",
      display: "Bone Mineral Densitometry",
    },
    MG: {
      code: "MG",
      system: "1.2.840.10008.2.16.4",
      display: "Mammography",
    },
    SM: {
      code: "SM",
      system: "1.2.840.10008.2.16.4",
      display: "Slide Microscopy",
    },
    US: {
      code: "US",
      system: "1.2.840.10008.2.16.4",
      display: "Ultrasound",
    },
    OP: {
      code: "OP",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Photography",
    },
    IVOCT: {
      code: "IVOCT",
      system: "1.2.840.10008.2.16.4",
      display: "Intravascular Optical Coherence Tomography",
    },
    MR: {
      code: "MR",
      system: "1.2.840.10008.2.16.4",
      display: "Magnetic Resonance",
    },
    ECG: {
      code: "ECG",
      system: "1.2.840.10008.2.16.4",
      display: "Electrocardiography",
    },
    GM: {
      code: "GM",
      system: "1.2.840.10008.2.16.4",
      display: "General Microscopy",
    },
    IO: {
      code: "IO",
      system: "1.2.840.10008.2.16.4",
      display: "Intra-oral Radiography",
    },
    XA: {
      code: "XA",
      system: "1.2.840.10008.2.16.4",
      display: "X-Ray Angiography",
    },
    XC: {
      code: "XC",
      system: "1.2.840.10008.2.16.4",
      display: "External-camera Photography",
    },
    VA: {
      code: "VA",
      system: "1.2.840.10008.2.16.4",
      display: "Visual Acuity",
    },
    IVUS: {
      code: "IVUS",
      system: "1.2.840.10008.2.16.4",
      display: "Intravascular Ultrasound",
    },
    CR: {
      code: "CR",
      system: "1.2.840.10008.2.16.4",
      display: "Computed Radiography",
    },
    ES: {
      code: "ES",
      system: "1.2.840.10008.2.16.4",
      display: "Endoscopy",
    },
    AR: {
      code: "AR",
      system: "1.2.840.10008.2.16.4",
      display: "Autorefraction",
    },
    CT: {
      code: "CT",
      system: "1.2.840.10008.2.16.4",
      display: "Computed Tomography",
    },
    OSS: {
      code: "OSS",
      system: "1.2.840.10008.2.16.4",
      display: "Optical Surface Scanner",
    },
    LEN: {
      code: "LEN",
      system: "1.2.840.10008.2.16.4",
      display: "Lensometry",
    },
    RG: {
      code: "RG",
      system: "1.2.840.10008.2.16.4",
      display: "Radiographic imaging",
    },
    RF: {
      code: "RF",
      system: "1.2.840.10008.2.16.4",
      display: "Radiofluoroscopy",
    },
    KER: {
      code: "KER",
      system: "1.2.840.10008.2.16.4",
      display: "Keratometry",
    },
    HD: {
      code: "HD",
      system: "1.2.840.10008.2.16.4",
      display: "Hemodynamic Waveform",
    },
    OAM: {
      code: "OAM",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Axial Measurements",
    },
    NM: {
      code: "NM",
      system: "1.2.840.10008.2.16.4",
      display: "Nuclear Medicine",
    },
    OCT: {
      code: "OCT",
      system: "1.2.840.10008.2.16.4",
      display: "Optical Coherence Tomography",
    },
    BDUS: {
      code: "BDUS",
      system: "1.2.840.10008.2.16.4",
      display: "Ultrasound Bone Densitometry",
    },
    PT: {
      code: "PT",
      system: "1.2.840.10008.2.16.4",
      display: "Positron emission tomography",
    },
    EPS: {
      code: "EPS",
      system: "1.2.840.10008.2.16.4",
      display: "Cardiac Electrophysiology",
    },
    PX: {
      code: "PX",
      system: "1.2.840.10008.2.16.4",
      display: "Panoramic X-Ray",
    },
    SRF: {
      code: "SRF",
      system: "1.2.840.10008.2.16.4",
      display: "Subjective Refraction",
    },
    OPM: {
      code: "OPM",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Mapping",
    },
    OPR: {
      code: "OPR",
      system: "1.2.840.10008.2.16.4",
      display: "Ophthalmic Refraction",
    },
  },
  formatCode: {
    "urn:che:epr:EPR_Unstructured_Document": {
      code: "urn:che:epr:EPR_Unstructured_Document",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "Unstructured EPR document",
    },
    "1.2.840.10008.5.1.4.1.1.88.59": {
      code: "1.2.840.10008.5.1.4.1.1.88.59",
      system: "1.2.840.10008.2.6.1",
      display: "DICOM Manifest (DICOM KOS SOP Class UID)",
    },
    "urn:ihe:rad:TEXT": {
      code: "urn:ihe:rad:TEXT",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "XDS-I CDA Wrapped Text Report (XDS-I)",
    },
    "urn:ihe:rad:PDF": {
      code: "urn:ihe:rad:PDF",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "XDS-I PDF (XDS-I)",
    },
    "urn:ihe:rad:CDA:ImagingReportStructuredHeadings:2013": {
      code: "urn:ihe:rad:CDA:ImagingReportStructuredHeadings:2013",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "XDS-I Imaging Report with Structured Headings (XDS-I)",
    },
    "urn:ihe:iti:xds-sd:pdf:2008": {
      code: "urn:ihe:iti:xds-sd:pdf:2008",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Scanned Documents (PDF)",
    },
    "urn:ihe:iti:xds-sd:text:2008": {
      code: "urn:ihe:iti:xds-sd:text:2008",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Scanned Documents (text)",
    },
    "urn:ihe:pharm:pml:2013": {
      code: "urn:ihe:pharm:pml:2013",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Community Medication List",
    },
    "urn:ihe:pharm:pre:2010": {
      code: "urn:ihe:pharm:pre:2010",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Community Prescription",
    },
    "urn:ihe:pharm:dis:2010": {
      code: "urn:ihe:pharm:dis:2010",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Community Dispense",
    },
    "urn:ihe:pharm:mtp:2015": {
      code: "urn:ihe:pharm:mtp:2015",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Community Medication Treatment Plan",
    },
    "urn:ihe:pharm:padv:2010": {
      code: "urn:ihe:pharm:padv:2010",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Community Pharmaceutical Advice",
    },
    "urn:ihe:lab:xd-lab:2008": {
      code: "urn:ihe:lab:xd-lab:2008",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "CDA Laboratory Report",
    },
    "urn:ihe:pcc:ic:2008": {
      code: "urn:ihe:pcc:ic:2008",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Immunization Registry Content (IRC)",
    },
    "urn:ihe:pcc:ic:2009": {
      code: "urn:ihe:pcc:ic:2009",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "Immunization Content (IC)",
    },
    "urn:ihe:iti:xds:2017:mimeTypeSufficient": {
      code: "urn:ihe:iti:xds:2017:mimeTypeSufficient",
      system: "1.3.6.1.4.1.19376.1.2.3",
      display: "MimeType sufficient",
    },
    "urn:che:epr:ch-emed:medication-card:2023": {
      code: "urn:che:epr:ch-emed:medication-card:2023",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH EMED Medication Card document",
    },
    "urn:che:epr:ch-allergyintolerance:2024": {
      code: "urn:che:epr:ch-allergyintolerance:2024",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH AllergyIntolerance document",
    },
    "urn:che:epr:ch-emed:dis:2024": {
      code: "urn:che:epr:ch-emed:dis:2024",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH EMED Medication Dispense document",
    },
    "urn:che:epr:ch-emed:mtp:2024": {
      code: "urn:che:epr:ch-emed:mtp:2024",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH EMED Medication Treatment Plan document",
    },
    "urn:che:epr:ch-emed:padv:2024": {
      code: "urn:che:epr:ch-emed:padv:2024",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH EMED Pharmaceutical Advice document",
    },
    "urn:che:epr:ch-emed:pml:2024": {
      code: "urn:che:epr:ch-emed:pml:2024",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH EMED Medication List document",
    },
    "urn:che:epr:ch-emed:pre:2024": {
      code: "urn:che:epr:ch-emed:pre:2024",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH EMED Medication Prescription document",
    },
    "urn:che:epr:ch-vacd:immunization-administration:2022": {
      code: "urn:che:epr:ch-vacd:immunization-administration:2022",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH VACD Immunization Administration",
    },
    "urn:che:epr:ch-vacd:vaccination-record:2022": {
      code: "urn:che:epr:ch-vacd:vaccination-record:2022",
      system: "2.16.756.5.30.1.127.3.10.10",
      display: "CH VACD Vaccination Record",
    },
  },
  healthcareFacilityTypeCode: {
    "22232009": {
      code: "22232009",
      system: "2.16.840.1.113883.6.96",
      display: "Hospital (environment)",
    },
    "35971002": {
      code: "35971002",
      system: "2.16.840.1.113883.6.96",
      display: "Ambulatory care site (environment)",
    },
    "42665001": {
      code: "42665001",
      system: "2.16.840.1.113883.6.96",
      display: "Nursing home (environment)",
    },
    "43741000": {
      code: "43741000",
      system: "2.16.840.1.113883.6.96",
      display: "Site of care (environment)",
    },
    "66280005": {
      code: "66280005",
      system: "2.16.840.1.113883.6.96",
      display: "Private home-based care (environment)",
    },
    "80522000": {
      code: "80522000",
      system: "2.16.840.1.113883.6.96",
      display: "Rehabilitation hospital (environment)",
    },
    "225728007": {
      code: "225728007",
      system: "2.16.840.1.113883.6.96",
      display: "Accident and Emergency department (environment)",
    },
    "264358009": {
      code: "264358009",
      system: "2.16.840.1.113883.6.96",
      display: "General practice premises (environment)",
    },
    "264372000": {
      code: "264372000",
      system: "2.16.840.1.113883.6.96",
      display: "Pharmacy (environment)",
    },
    "288565001": {
      code: "288565001",
      system: "2.16.840.1.113883.6.96",
      display: "Medical center (environment)",
    },
    "394747008": {
      code: "394747008",
      system: "2.16.840.1.113883.6.96",
      display: "Health Authority (qualifier value)",
    },
    "394778007": {
      code: "394778007",
      system: "2.16.840.1.113883.6.96",
      display: "Client's or patient's home (environment)",
    },
    "722171005": {
      code: "722171005",
      system: "2.16.840.1.113883.6.96",
      display: "Diagnostic institution (environment)",
    },
    "722172003": {
      code: "722172003",
      system: "2.16.840.1.113883.6.96",
      display: "Military health institution (environment)",
    },
    "722173008": {
      code: "722173008",
      system: "2.16.840.1.113883.6.96",
      display: "Prison based care site (environment)",
    },
    "91154008": {
      code: "91154008",
      system: "2.16.840.1.113883.6.96",
      display: "Free-standing birthing center (environment)",
    },
    "22201008": {
      code: "22201008",
      system: "2.16.840.1.113883.6.96",
      display: "Free-standing dental clinic (environment)",
    },
  },
  languageCode: {
    ar: {
      code: "ar",
      system: "2.16.840.1.113883.6.316",
      display: "Arabic",
    },
    bn: {
      code: "bn",
      system: "2.16.840.1.113883.6.316",
      display: "Bengali",
    },
    cs: {
      code: "cs",
      system: "2.16.840.1.113883.6.316",
      display: "Czech",
    },
    da: {
      code: "da",
      system: "2.16.840.1.113883.6.316",
      display: "Danish",
    },
    de: {
      code: "de",
      system: "2.16.840.1.113883.6.316",
      display: "German",
    },
    "de-AT": {
      code: "de-AT",
      system: "2.16.840.1.113883.6.316",
      display: "German (Austria)",
    },
    "de-CH": {
      code: "de-CH",
      system: "2.16.840.1.113883.6.316",
      display: "German (Switzerland)",
    },
    "de-DE": {
      code: "de-DE",
      system: "2.16.840.1.113883.6.316",
      display: "German (Germany)",
    },
    el: {
      code: "el",
      system: "2.16.840.1.113883.6.316",
      display: "Greek",
    },
    en: {
      code: "en",
      system: "2.16.840.1.113883.6.316",
      display: "English",
    },
    "en-AU": {
      code: "en-AU",
      system: "2.16.840.1.113883.6.316",
      display: "English (Australia)",
    },
    "en-CA": {
      code: "en-CA",
      system: "2.16.840.1.113883.6.316",
      display: "English (Canada)",
    },
    "en-GB": {
      code: "en-GB",
      system: "2.16.840.1.113883.6.316",
      display: "English (Great Britain)",
    },
    "en-IN": {
      code: "en-IN",
      system: "2.16.840.1.113883.6.316",
      display: "English (India)",
    },
    "en-NZ": {
      code: "en-NZ",
      system: "2.16.840.1.113883.6.316",
      display: "English (New Zealand)",
    },
    "en-SG": {
      code: "en-SG",
      system: "2.16.840.1.113883.6.316",
      display: "English (Singapore)",
    },
    "en-US": {
      code: "en-US",
      system: "2.16.840.1.113883.6.316",
      display: "English (United States)",
    },
    es: {
      code: "es",
      system: "2.16.840.1.113883.6.316",
      display: "Spanish",
    },
    "es-AR": {
      code: "es-AR",
      system: "2.16.840.1.113883.6.316",
      display: "Spanish (Argentina)",
    },
    "es-ES": {
      code: "es-ES",
      system: "2.16.840.1.113883.6.316",
      display: "Spanish (Spain)",
    },
    "es-UY": {
      code: "es-UY",
      system: "2.16.840.1.113883.6.316",
      display: "Spanish (Uruguay)",
    },
    fi: {
      code: "fi",
      system: "2.16.840.1.113883.6.316",
      display: "Finnish",
    },
    fr: {
      code: "fr",
      system: "2.16.840.1.113883.6.316",
      display: "French",
    },
    "fr-BE": {
      code: "fr-BE",
      system: "2.16.840.1.113883.6.316",
      display: "French (Belgium)",
    },
    "fr-CH": {
      code: "fr-CH",
      system: "2.16.840.1.113883.6.316",
      display: "French (Switzerland)",
    },
    "fr-FR": {
      code: "fr-FR",
      system: "2.16.840.1.113883.6.316",
      display: "French (France)",
    },
    fy: {
      code: "fy",
      system: "2.16.840.1.113883.6.316",
      display: "Frysian",
    },
    "fy-NL": {
      code: "fy-NL",
      system: "2.16.840.1.113883.6.316",
      display: "Frysian (Netherlands)",
    },
    hi: {
      code: "hi",
      system: "2.16.840.1.113883.6.316",
      display: "Hindi",
    },
    hr: {
      code: "hr",
      system: "2.16.840.1.113883.6.316",
      display: "Croatian",
    },
    it: {
      code: "it",
      system: "2.16.840.1.113883.6.316",
      display: "Italian",
    },
    "it-CH": {
      code: "it-CH",
      system: "2.16.840.1.113883.6.316",
      display: "Italian (Switzerland)",
    },
    "it-IT": {
      code: "it-IT",
      system: "2.16.840.1.113883.6.316",
      display: "Italian (Italy)",
    },
    ja: {
      code: "ja",
      system: "2.16.840.1.113883.6.316",
      display: "Japanese",
    },
    ko: {
      code: "ko",
      system: "2.16.840.1.113883.6.316",
      display: "Korean",
    },
    nl: {
      code: "nl",
      system: "2.16.840.1.113883.6.316",
      display: "Dutch",
    },
    "nl-BE": {
      code: "nl-BE",
      system: "2.16.840.1.113883.6.316",
      display: "Dutch (Belgium)",
    },
    "nl-NL": {
      code: "nl-NL",
      system: "2.16.840.1.113883.6.316",
      display: "Dutch (Netherlands)",
    },
    no: {
      code: "no",
      system: "2.16.840.1.113883.6.316",
      display: "Norwegian",
    },
    "no-NO": {
      code: "no-NO",
      system: "2.16.840.1.113883.6.316",
      display: "Norwegian (Norway)",
    },
    pa: {
      code: "pa",
      system: "2.16.840.1.113883.6.316",
      display: "Punjabi",
    },
    pl: {
      code: "pl",
      system: "2.16.840.1.113883.6.316",
      display: "Polish",
    },
    pt: {
      code: "pt",
      system: "2.16.840.1.113883.6.316",
      display: "Portuguese",
    },
    "pt-BR": {
      code: "pt-BR",
      system: "2.16.840.1.113883.6.316",
      display: "Portuguese (Brazil)",
    },
    rm: {
      code: "rm",
      system: "2.16.840.1.113883.6.316",
      display: "Romansh",
    },
    ru: {
      code: "ru",
      system: "2.16.840.1.113883.6.316",
      display: "Russian",
    },
    "ru-RU": {
      code: "ru-RU",
      system: "2.16.840.1.113883.6.316",
      display: "Russian (Russia)",
    },
    sr: {
      code: "sr",
      system: "2.16.840.1.113883.6.316",
      display: "Serbian",
    },
    "sr-RS": {
      code: "sr-RS",
      system: "2.16.840.1.113883.6.316",
      display: "Serbian (Serbia)",
    },
    sv: {
      code: "sv",
      system: "2.16.840.1.113883.6.316",
      display: "Swedish",
    },
    "sv-SE": {
      code: "sv-SE",
      system: "2.16.840.1.113883.6.316",
      display: "Swedish (Sweden)",
    },
    te: {
      code: "te",
      system: "2.16.840.1.113883.6.316",
      display: "Telegu",
    },
    zh: {
      code: "zh",
      system: "2.16.840.1.113883.6.316",
      display: "Chinese",
    },
    "zh-CN": {
      code: "zh-CN",
      system: "2.16.840.1.113883.6.316",
      display: "Chinese (China)",
    },
    "zh-HK": {
      code: "zh-HK",
      system: "2.16.840.1.113883.6.316",
      display: "Chinese (Hong Kong)",
    },
    "zh-SG": {
      code: "zh-SG",
      system: "2.16.840.1.113883.6.316",
      display: "Chinese (Singapore)",
    },
    "zh-TW": {
      code: "zh-TW",
      system: "2.16.840.1.113883.6.316",
      display: "Chinese (Taiwan)",
    },
    OTHER: {
      code: "OTHER",
      system: "2.16.756.5.30.1.127.3.10.12",
      display: "Other language",
    },
  },
  mimeType: {
    "application/dicom": {
      code: "application/dicom",
      system: "2.16.840.1.113883.5.79",
      display: "DICOM",
    },
    "application/fhir+json": {
      code: "application/fhir+json",
      system: "2.16.840.1.113883.5.79",
      display: "FHIR (JSON)",
    },
    "application/fhir+xml": {
      code: "application/fhir+xml",
      system: "2.16.840.1.113883.5.79",
      display: "FHIR (XML)",
    },
    "application/pdf": {
      code: "application/pdf",
      system: "2.16.840.1.113883.5.79",
      display: "PDF",
    },
    "audio/mp4": {
      code: "audio/mp4",
      system: "2.16.840.1.113883.5.79",
      display: "MP4 Audio",
    },
    "audio/mpeg": {
      code: "audio/mpeg",
      system: "2.16.840.1.113883.5.79",
      display: "MPEG audio layer 3",
    },
    "image/gif": {
      code: "image/gif",
      system: "2.16.840.1.113883.5.79",
      display: "GIF Graphics Interchange Format",
    },
    "image/jp2": {
      code: "image/jp2",
      system: "2.16.840.1.113883.5.79",
      display: "JPEG 2000 Core Image File",
    },
    "image/jpeg": {
      code: "image/jpeg",
      system: "2.16.840.1.113883.5.79",
      display: "JPEG Image",
    },
    "image/jpm": {
      code: "image/jpm",
      system: "2.16.840.1.113883.5.79",
      display: "JPEG 2000 Compound Image File",
    },
    "image/jpx": {
      code: "image/jpx",
      system: "2.16.840.1.113883.5.79",
      display: "JPEG 2000 Image File",
    },
    "image/png": {
      code: "image/png",
      system: "2.16.840.1.113883.5.79",
      display: "PNG Portable Network Graphics",
    },
    "image/tiff": {
      code: "image/tiff",
      system: "2.16.840.1.113883.5.79",
      display: "TIFF Image",
    },
    "model/vrml": {
      code: "model/vrml",
      system: "2.16.840.1.113883.5.79",
      display: "Virtual Reality Modeling Language",
    },
    "model/x3d+xml": {
      code: "model/x3d+xml",
      system: "2.16.840.1.113883.5.79",
      display: "Extensible 3D Graphics (XML)",
    },
    "model/x3d-vrml": {
      code: "model/x3d-vrml",
      system: "2.16.840.1.113883.5.79",
      display: "Extensible 3D Graphics (VRML)",
    },
    "multipart/multilingual": {
      code: "multipart/multilingual",
      system: "2.16.840.1.113883.5.79",
      display: "Multilingual Multipart",
    },
    "multipart/signed": {
      code: "multipart/signed",
      system: "2.16.840.1.113883.5.79",
      display: "Signed Multipart",
    },
    "multipart/x-hl7-cda-level1": {
      code: "multipart/x-hl7-cda-level1",
      system: "2.16.840.1.113883.5.79",
      display: "CDA Level 1 Multipart",
    },
    "text/csv": {
      code: "text/csv",
      system: "2.16.840.1.113883.5.79",
      display: "CSV Comma-separated Values",
    },
    "text/plain": {
      code: "text/plain",
      system: "2.16.840.1.113883.5.79",
      display: "Plain Text",
    },
    "text/xml": {
      code: "text/xml",
      system: "2.16.840.1.113883.5.79",
      display: "XML-Text",
    },
    "video/mj2": {
      code: "video/mj2",
      system: "2.16.840.1.113883.5.79",
      display: "Motion JPEG 2000",
    },
    "video/mp4": {
      code: "video/mp4",
      system: "2.16.840.1.113883.5.79",
      display: "MPEG-4 Part 14",
    },
    "video/mpeg": {
      code: "video/mpeg",
      system: "2.16.840.1.113883.5.79",
      display: "MPEG Video",
    },
  },
  practiceSettingCode: {
    "310025004": {
      code: "310025004",
      system: "2.16.840.1.113883.6.96",
      display: "Complementary therapy service (qualifier value)",
    },
    "310080006": {
      code: "310080006",
      system: "2.16.840.1.113883.6.96",
      display: "Pharmacy service (qualifier value)",
    },
    "310087009": {
      code: "310087009",
      system: "2.16.840.1.113883.6.96",
      display: "Podiatry service (qualifier value)",
    },
    "310093001": {
      code: "310093001",
      system: "2.16.840.1.113883.6.96",
      display: "Occupational therapy service (qualifier value)",
    },
    "310101009": {
      code: "310101009",
      system: "2.16.840.1.113883.6.96",
      display: "Speech and language therapy service (qualifier value)",
    },
    "394537008": {
      code: "394537008",
      system: "2.16.840.1.113883.6.96",
      display: "Pediatric specialty (qualifier value)",
    },
    "394576009": {
      code: "394576009",
      system: "2.16.840.1.113883.6.96",
      display: "Accident &amp; emergency (qualifier value)",
    },
    "394577000": {
      code: "394577000",
      system: "2.16.840.1.113883.6.96",
      display: "Anesthetics (qualifier value)",
    },
    "394579002": {
      code: "394579002",
      system: "2.16.840.1.113883.6.96",
      display: "Cardiology (qualifier value)",
    },
    "394580004": {
      code: "394580004",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical genetics (qualifier value)",
    },
    "394582007": {
      code: "394582007",
      system: "2.16.840.1.113883.6.96",
      display: "Dermatology (qualifier value)",
    },
    "394583002": {
      code: "394583002",
      system: "2.16.840.1.113883.6.96",
      display: "Endocrinology (qualifier value)",
    },
    "394584008": {
      code: "394584008",
      system: "2.16.840.1.113883.6.96",
      display: "Gastroenterology (qualifier value)",
    },
    "394586005": {
      code: "394586005",
      system: "2.16.840.1.113883.6.96",
      display: "Gynecology (qualifier value)",
    },
    "394587001": {
      code: "394587001",
      system: "2.16.840.1.113883.6.96",
      display: "Psychiatry (qualifier value)",
    },
    "394589003": {
      code: "394589003",
      system: "2.16.840.1.113883.6.96",
      display: "Nephrology (qualifier value)",
    },
    "394591006": {
      code: "394591006",
      system: "2.16.840.1.113883.6.96",
      display: "Neurology (qualifier value)",
    },
    "394592004": {
      code: "394592004",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical oncology (qualifier value)",
    },
    "394594003": {
      code: "394594003",
      system: "2.16.840.1.113883.6.96",
      display: "Ophthalmology (qualifier value)",
    },
    "394595002": {
      code: "394595002",
      system: "2.16.840.1.113883.6.96",
      display: "Pathology (qualifier value)",
    },
    "394600006": {
      code: "394600006",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical pharmacology (qualifier value)",
    },
    "394602003": {
      code: "394602003",
      system: "2.16.840.1.113883.6.96",
      display: "Rehabilitation - specialty (qualifier value)",
    },
    "394609007": {
      code: "394609007",
      system: "2.16.840.1.113883.6.96",
      display: "General surgery (qualifier value)",
    },
    "394610002": {
      code: "394610002",
      system: "2.16.840.1.113883.6.96",
      display: "Neurosurgery (qualifier value)",
    },
    "394611003": {
      code: "394611003",
      system: "2.16.840.1.113883.6.96",
      display: "Plastic surgery - specialty (qualifier value)",
    },
    "394612005": {
      code: "394612005",
      system: "2.16.840.1.113883.6.96",
      display: "Urology (qualifier value)",
    },
    "394649004": {
      code: "394649004",
      system: "2.16.840.1.113883.6.96",
      display: "Nuclear medicine - specialty (qualifier value)",
    },
    "394658006": {
      code: "394658006",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical specialty (qualifier value)",
    },
    "394801008": {
      code: "394801008",
      system: "2.16.840.1.113883.6.96",
      display: "Trauma and orthopedics (qualifier value)",
    },
    "394802001": {
      code: "394802001",
      system: "2.16.840.1.113883.6.96",
      display: "General medicine (qualifier value)",
    },
    "394803006": {
      code: "394803006",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical hematology (qualifier value)",
    },
    "394805004": {
      code: "394805004",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical immunology/allergy (qualifier value)",
    },
    "394806003": {
      code: "394806003",
      system: "2.16.840.1.113883.6.96",
      display: "Palliative medicine (qualifier value)",
    },
    "394807007": {
      code: "394807007",
      system: "2.16.840.1.113883.6.96",
      display: "Infectious diseases (specialty) (qualifier value)",
    },
    "394810000": {
      code: "394810000",
      system: "2.16.840.1.113883.6.96",
      display: "Rheumatology (qualifier value)",
    },
    "394811001": {
      code: "394811001",
      system: "2.16.840.1.113883.6.96",
      display: "Geriatric medicine (qualifier value)",
    },
    "394812008": {
      code: "394812008",
      system: "2.16.840.1.113883.6.96",
      display: "Dental medicine specialties (qualifier value)",
    },
    "394819004": {
      code: "394819004",
      system: "2.16.840.1.113883.6.96",
      display: "Blood transfusion (specialty) (qualifier value)",
    },
    "394914008": {
      code: "394914008",
      system: "2.16.840.1.113883.6.96",
      display: "Radiology - specialty (qualifier value)",
    },
    "408448007": {
      code: "408448007",
      system: "2.16.840.1.113883.6.96",
      display: "Tropical medicine (qualifier value)",
    },
    "408456005": {
      code: "408456005",
      system: "2.16.840.1.113883.6.96",
      display: "Thoracic surgery (qualifier value)",
    },
    "408463005": {
      code: "408463005",
      system: "2.16.840.1.113883.6.96",
      display: "Vascular surgery (qualifier value)",
    },
    "408465003": {
      code: "408465003",
      system: "2.16.840.1.113883.6.96",
      display: "Oral and maxillofacial surgery (qualifier value)",
    },
    "408466002": {
      code: "408466002",
      system: "2.16.840.1.113883.6.96",
      display: "Cardiac surgery (qualifier value)",
    },
    "408470005": {
      code: "408470005",
      system: "2.16.840.1.113883.6.96",
      display: "Obstetrics (qualifier value)",
    },
    "408477008": {
      code: "408477008",
      system: "2.16.840.1.113883.6.96",
      display: "Transplantation surgery (qualifier value)",
    },
    "408478003": {
      code: "408478003",
      system: "2.16.840.1.113883.6.96",
      display: "Critical care medicine (qualifier value)",
    },
    "408480009": {
      code: "408480009",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical immunology (qualifier value)",
    },
    "409968004": {
      code: "409968004",
      system: "2.16.840.1.113883.6.96",
      display: "Preventive medicine (qualifier value)",
    },
    "416304004": {
      code: "416304004",
      system: "2.16.840.1.113883.6.96",
      display: "Osteopathic manipulative medicine (qualifier value)",
    },
    "418112009": {
      code: "418112009",
      system: "2.16.840.1.113883.6.96",
      display: "Pulmonary medicine (qualifier value)",
    },
    "418960008": {
      code: "418960008",
      system: "2.16.840.1.113883.6.96",
      display: "Otolaryngology (qualifier value)",
    },
    "419192003": {
      code: "419192003",
      system: "2.16.840.1.113883.6.96",
      display: "Internal medicine (qualifier value)",
    },
    "419815003": {
      code: "419815003",
      system: "2.16.840.1.113883.6.96",
      display: "Radiation oncology (qualifier value)",
    },
    "708184003": {
      code: "708184003",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical pathology service (qualifier value)",
    },
    "721961006": {
      code: "721961006",
      system: "2.16.840.1.113883.6.96",
      display: "Psychosomatic medicine (qualifier value)",
    },
    "722138006": {
      code: "722138006",
      system: "2.16.840.1.113883.6.96",
      display: "Physiotherapy (qualifier value)",
    },
    "722162001": {
      code: "722162001",
      system: "2.16.840.1.113883.6.96",
      display: "Psychology (qualifier value)",
    },
    "722163006": {
      code: "722163006",
      system: "2.16.840.1.113883.6.96",
      display: "Dentistry (qualifier value)",
    },
    "722164000": {
      code: "722164000",
      system: "2.16.840.1.113883.6.96",
      display: "Dietetics and nutrition (qualifier value)",
    },
    "722165004": {
      code: "722165004",
      system: "2.16.840.1.113883.6.96",
      display: "Nursing (qualifier value)",
    },
    "722170006": {
      code: "722170006",
      system: "2.16.840.1.113883.6.96",
      display: "Chiropractic service (qualifier value)",
    },
    "722204007": {
      code: "722204007",
      system: "2.16.840.1.113883.6.96",
      display: "Legal medicine (qualifier value)",
    },
    "722414000": {
      code: "722414000",
      system: "2.16.840.1.113883.6.96",
      display: "Vascular medicine (qualifier value)",
    },
    "773568002": {
      code: "773568002",
      system: "2.16.840.1.113883.6.96",
      display: "Emergency medicine (qualifier value)",
    },
  },
  sourcePatientInfo: {
    female: {
      code: "female",
      system: "2.16.840.1.113883.4.642.1.2",
      display: "Female",
    },
    male: {
      code: "male",
      system: "2.16.840.1.113883.4.642.1.2",
      display: "Male",
    },
    other: {
      code: "other",
      system: "2.16.840.1.113883.4.642.1.2",
      display: "Other",
    },
    unknown: {
      code: "unknown",
      system: "2.16.840.1.113883.4.642.1.2",
      display: "Unknown",
    },
  },
  typeCode: {
    "371526002": {
      code: "371526002",
      system: "2.16.840.1.113883.6.96",
      display: "Operative report (record artifact)",
    },
    "371528001": {
      code: "371528001",
      system: "2.16.840.1.113883.6.96",
      display: "Pathology report (record artifact)",
    },
    "371529009": {
      code: "371529009",
      system: "2.16.840.1.113883.6.96",
      display: "History and physical report (record artifact)",
    },
    "371530004": {
      code: "371530004",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical consultation report (record artifact)",
    },
    "371532007": {
      code: "371532007",
      system: "2.16.840.1.113883.6.96",
      display: "Progress report (record artifact)",
    },
    "371535009": {
      code: "371535009",
      system: "2.16.840.1.113883.6.96",
      display: "Transfer summary report (record artifact)",
    },
    "373942005": {
      code: "373942005",
      system: "2.16.840.1.113883.6.96",
      display: "Discharge summary (record artifact)",
    },
    "419891008": {
      code: "419891008",
      system: "2.16.840.1.113883.6.96",
      display: "Record artifact (record artifact)",
    },
    "445300006": {
      code: "445300006",
      system: "2.16.840.1.113883.6.96",
      display: "Emergency department record (record artifact)",
    },
    "445418005": {
      code: "445418005",
      system: "2.16.840.1.113883.6.96",
      display: "Professional allied to medicine clinical report (record artifact)",
    },
    "721912009": {
      code: "721912009",
      system: "2.16.840.1.113883.6.96",
      display: "Medication summary document (record artifact)",
    },
    "721965002": {
      code: "721965002",
      system: "2.16.840.1.113883.6.96",
      display: "Laboratory order (record artifact)",
    },
    "721966001": {
      code: "721966001",
      system: "2.16.840.1.113883.6.96",
      display: "Pathology order (record artifact)",
    },
    "722446000": {
      code: "722446000",
      system: "2.16.840.1.113883.6.96",
      display: "Allergy record (record artifact)",
    },
    "736055001": {
      code: "736055001",
      system: "2.16.840.1.113883.6.96",
      display: "Rehabilitation care plan (record artifact)",
    },
    "737427001": {
      code: "737427001",
      system: "2.16.840.1.113883.6.96",
      display: "Clinical management plan (record artifact)",
    },
    "761938008": {
      code: "761938008",
      system: "2.16.840.1.113883.6.96",
      display: "Medical prescription record (record artifact)",
    },
    "765492005": {
      code: "765492005",
      system: "2.16.840.1.113883.6.96",
      display: "Non-drug prescription record (record artifact)",
    },
    "772786005": {
      code: "772786005",
      system: "2.16.840.1.113883.6.96",
      display: "Medical certificate (record artifact)",
    },
    "773130005": {
      code: "773130005",
      system: "2.16.840.1.113883.6.96",
      display: "Nursing care plan (record artifact)",
    },
    "2161000195103": {
      code: "2161000195103",
      system: "2.16.756.5.30.1.127.3.4",
      display: "Imaging order (record artifact)",
    },
    "4201000179104": {
      code: "4201000179104",
      system: "2.16.840.1.113883.6.96",
      display: "Imaging report (record artifact)",
    },
    "4241000179101": {
      code: "4241000179101",
      system: "2.16.840.1.113883.6.96",
      display: "Laboratory report (record artifact)",
    },
    "900000000000471006": {
      code: "900000000000471006",
      system: "2.16.840.1.113883.6.96",
      display: "Image reference (foundation metadata concept)",
    },
    "41000179103": {
      code: "41000179103",
      system: "2.16.840.1.113883.6.96",
      display: "Immunization record (record artifact)",
    },
    "761931002": {
      code: "761931002",
      system: "2.16.840.1.113883.6.96",
      display: "Medication treatment plan report (record artifact)",
    },
    "736378000": {
      code: "736378000",
      system: "2.16.840.1.113883.6.96",
      display: "Medication management plan (record artifact)",
    },
    "787148009": {
      code: "787148009",
      system: "2.16.840.1.113883.6.96",
      display: "Digital representation of specimen (record artifact)",
    },
    "82291000195104": {
      code: "82291000195104",
      system: "2.16.756.5.30.1.127.3.4",
      display: "Medication dispense document (record artifact)",
    },
  },
  hcProfession: {
    "3842006": {
      code: "3842006",
      system: "2.16.840.1.113883.6.96",
      display: "Chiropractor (occupation)",
    },
    "36682004": {
      code: "36682004",
      system: "2.16.840.1.113883.6.96",
      display: "Physiotherapist (occupation)",
    },
    "46255001": {
      code: "46255001",
      system: "2.16.840.1.113883.6.96",
      display: "Pharmacist (occupation)",
    },
    "59944000": {
      code: "59944000",
      system: "2.16.840.1.113883.6.96",
      display: "Psychologist (occupation)",
    },
    "80546007": {
      code: "80546007",
      system: "2.16.840.1.113883.6.96",
      display: "Occupational therapist (occupation)",
    },
    "106289002": {
      code: "106289002",
      system: "2.16.840.1.113883.6.96",
      display: "Dentist (occupation)",
    },
    "106292003": {
      code: "106292003",
      system: "2.16.840.1.113883.6.96",
      display: "Professional nurse (occupation)",
    },
    "159026005": {
      code: "159026005",
      system: "2.16.840.1.113883.6.96",
      display: "Speech/language therapist (occupation)",
    },
    "159033005": {
      code: "159033005",
      system: "2.16.840.1.113883.6.96",
      display: "Dietitian (occupation)",
    },
    "309343006": {
      code: "309343006",
      system: "2.16.840.1.113883.6.96",
      display: "Physician (occupation)",
    },
    "309453006": {
      code: "309453006",
      system: "2.16.840.1.113883.6.96",
      display: "Registered midwife (occupation)",
    },
    "00000": {
      code: "00000",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Other",
    },
    "00100": {
      code: "00100",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Aktivierungsfachfrau/Aktivierungsfachmann",
    },
    "00200": {
      code: "00200",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Optician",
    },
    "00300": {
      code: "00300",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Biomedizinische Analytikerin/Biomedizinischer Analytiker",
    },
    "00400": {
      code: "00400",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Dental hygienist",
    },
    "00500": {
      code: "00500",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Drogist/Drogistin",
    },
    "00600": {
      code: "00600",
      system: "2.16.756.5.30.1.127.3.10.9",
      display:
        "Fachfrau für medizinisch-technische Radiologie/Fachmann für medizinisch-technische Radiologie",
    },
    "00700": {
      code: "00700",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Fachfrau Gesundheit/Fachmann Gesundheit",
    },
    "00800": {
      code: "00800",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Fachfrau Operationstechnik/Fachmann Operationstechnik",
    },
    "00900": {
      code: "00900",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Medizinische Masseurin/Medizinischer Masseur",
    },
    "01000": {
      code: "01000",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Naturheilpraktikerin/Naturheilpraktiker",
    },
    "01100": {
      code: "01100",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Optometrist",
    },
    "01200": {
      code: "01200",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Orthoptist",
    },
    "01300": {
      code: "01300",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Osteopath",
    },
    "01400": {
      code: "01400",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Podologin/Podologe",
    },
    "01500": {
      code: "01500",
      system: "2.16.756.5.30.1.127.3.10.9",
      display: "Rettungssanitäterin/Rettungssanitäter",
    },
  },
};
